import { LinkTag } from '@thd-nucleus/thd-helmet';
import { PLP_PAGE, NTT_PREFIX, PRODUCT_POD_COUNT } from '../../constants';

export const getItemIds = (products = []) => {
  return products.map(({ itemId }) => itemId);
};

export const getServerPageSize = ({ isSearch, isBrowse } = {}) => {
  if (isSearch) return PRODUCT_POD_COUNT.SERVER_SEARCH;
  if (isBrowse) return PRODUCT_POD_COUNT.SERVER_BROWSE;
  return PRODUCT_POD_COUNT.SERVER;
};

export const getIsEtchVisNavOnPLP = (data, isB2BCustomer) => {
  try {
    const stringifiedPartialTemplates = data?.searchModel?.partialTemplates;
    const isPLPPage = data?.searchModel?.metadata?.contentType === PLP_PAGE;
    const etchVisualNavExists = (stringifiedPartialTemplates?.[0] || '').indexOf('visualNavigation') > -1;
    let partialTemplates = (stringifiedPartialTemplates || []).map((template) => JSON.parse(template)) || [];
    const hasPLPBanner = data?.searchModel?.metadata?.hasPLPBanner;

    if (isB2BCustomer) return hasPLPBanner && etchVisualNavExists && isPLPPage;

    const plpBanner = partialTemplates?.[0]?.[Object.keys(partialTemplates?.[0])
      ?.find((type) => type === 'PLP_Banner')];
    return (!!plpBanner && plpBanner?.Content?.length > 0) && etchVisualNavExists && isPLPPage;
  } catch (err) {
    return false;
  }
};

export const onStoreChange = ({ output }) => {
  const { storeId: updatedStoreId } = output || {};

  if (updatedStoreId && window && window.THD_LOCALIZER_AUTO_INIT && window.THD_LOCALIZER_AUTO_INIT.Localizer) {
    window.THD_LOCALIZER_AUTO_INIT.Localizer
      .localize({ storeId: updatedStoreId })
      .then(() => {
        window.location.reload();
      });
  }
};

export const getContentfulPreviewCustomerType = (pathname) => {
  if (typeof pathname === 'string') {
    const customerTypeMatch = pathname.match(/b2[b|c]$/g);
    return customerTypeMatch[0] || '';
  }
  return '';
};

export const getContentfulPreviewPathName = (pathname) => {
  if (typeof pathname === 'string') {
    return pathname.replace(/-b2[b|c]$/, '');
  }
  return '';
};

export const impProductPodData = (layoutID) => {
  return {
    id: layoutID || '',
    component: 'ResultsWrapped',
    name: 'ProductListing',
    type: 'product'
  };
};

export const impPLPRecs = () => {
  return {
    id: '',
    component: 'DynamicRecs',
    type: 'product'
  };
};

export const isRefinedPage = (path) => {
  return path.includes(NTT_PREFIX) || false;
};

// Appends Image Manager query params to request a more appropriate sized hero image size.
const akamaiImageResize = (imageUrlToTransform) => {
  // Specific to Hero image size.
  const queryParams = 'Resize=(920,575)';

  if (!imageUrlToTransform) {
    return imageUrlToTransform;
  }
  const isAkamaiHost = imageUrlToTransform.includes('thdstatic.com');
  if (!isAkamaiHost) {
    return imageUrlToTransform;
  }
  if (!imageUrlToTransform.includes('?')) {
    return `${imageUrlToTransform}?im=${queryParams}`;
  }
  if (imageUrlToTransform.includes('im=')) {
    const urlBeforeImParams = imageUrlToTransform.substring(0, imageUrlToTransform.indexOf('im='));
    const imAndRemainderParams = imageUrlToTransform.substring(imageUrlToTransform.indexOf('im='));
    const hasAdditionalParams = imAndRemainderParams.includes('&');
    if (hasAdditionalParams) {
      const remainderOfParams = imAndRemainderParams.substring(imAndRemainderParams.indexOf('&'));
      const imParams = imAndRemainderParams.substring(0, imAndRemainderParams.indexOf('&'));
      return `${urlBeforeImParams}${imParams};${queryParams}${remainderOfParams}`;
    }
    return `${imageUrlToTransform};${queryParams}`;
  }
  return `${imageUrlToTransform}&im=${queryParams}`;
};

// To help lower LCP, if the heroCarousel is configured in Contentful, try to determine which image will be rendered
// to the top of the page. Once determine, add that URL to the head of the page so it'll load as soon as the page
// loads.
export const imagePreloader = ({ data: contentData }) => {
  const heroCarousel = contentData?.layouts?.content?.heroCarousel;
  if (!heroCarousel) {
    return [];
  }

  const firstComponent = heroCarousel.components[0];
  const componentType = firstComponent.__typename;
  let componentWithImage = firstComponent;
  if (componentType === 'ComponentSelector') {
    let { defaultComponent } = firstComponent;
    if (defaultComponent.__typename === 'Slot') {
      componentWithImage = defaultComponent.content;
    } else {
      componentWithImage = defaultComponent;
    }
  }

  const imageUrlToPreload = (componentWithImage?.previewImage?.damContentSelector?.assetData?.[0]?.selectedImageUrl
    || componentWithImage?.previewImage?.damDownloadedContent?.url
    || componentWithImage?.image?.url);

  if (!imageUrlToPreload) {
    return [];
  }

  const imageUrlToPreloadWithParams = akamaiImageResize(imageUrlToPreload);

  const tags = [
    new LinkTag({
      rel: 'preload', fetchPriority: 'high', href: imageUrlToPreloadWithParams, id: 'preloadFirstImg', as: 'image'
    })
  ];

  return tags;
};

export const isNIncluded = (value) => {
  return value?.includes('N-');
};
